import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { buttonClasses } from '@forecastify/ui';
import { useT } from '../i18n';
import { SIGN_IN_PATH } from '../routes';
import { AuthCard, AuthLede } from '../chrome/auth-card';

/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ *Kijelentkeztél* — where an ended session lands.                          │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * ⚠️ **A link, not a button**: signing in again is going to an address, and an anchor is what
 * survives a middle-click and what the reachability check can see.
 */
export function SignedOutScreen(): ReactNode {
  const t = useT();
  return (
    <AuthCard screen="signed-out" title={t('signedOut.title')}>
      <AuthLede>{t('signedOut.lede')}</AuthLede>
      <Link to={SIGN_IN_PATH} className={buttonClasses('default', 'lg', 'w-full')}>
        {t('signedOut.again')}
      </Link>
    </AuthCard>
  );
}
